module.exports = __webpack_public_path__ + "img/Image_06.c1afe533.jpg";